import React, { useState } from 'react'

export default function Workshops() {
  const workshops = [
    {
      id: 1,
      title: 'Agentic AI in Education: From Concept to Classroom',
      organization: 'IBM',
      status: 'مؤكد',
      goal: 'To enhance future-ready education by promoting innovative teaching practices, strengthening digital collaboration, leveraging data-driven insights.',
      language: ['انجليزي'],
      audience: ['أعضاء هيئة التدريس'],
      level: ['أساسي', 'متوسط'],
      date: '19/1/2026 يوم الاثنين',
      dayKey: 'mon',
      time: '12:30 – 3:30 م',
      location: 'الدرعية',
      requirements:
        'المتحدثون: Safae، Rasul، Ebin، Yousof Kayal. -احضار جهاز حاسب محمول بمواصفات (8GB RAM, i5 or equivalent). -يفضل الإلمام الأساسي بأدوات الذكاء الاصطناعي. -سوف يتم ارسال رابط لإنشاء حساب IBM Cloud التجريبي قبل بدء ورشة العمل. تقديم شهادة الكترونية تقدم IBM. جهاز عرض وشاشة موثوقان للعروض التقديمية. ميكروفونات وسماعات لضمان وضوح الصوت أثناء الجلسات. إنترنت عالي السرعة (10 ميجابت في الثانية كحد أدنى لكل مستخدم).',
      capacity: '-',
    },
    {
      id: 2,
      title: 'التدريب وبناء القدرات من أجل مستقبل تنافسي',
      organization: 'Informa',
      status: 'مؤكد',
      goal: 'تمكين الأفراد من فهم متطلبات المستقبل التنافسي وتطوير مهاراتهم وقدراتهم بما يتوافق مع احتياجات سوق العمل السعودي.',
      language: ['انجليزي', 'عربي'],
      audience: ['أعضاء هيئة تدريس', 'موظفين', 'طلاب'],
      level: ['متوسط'],
      date: '19/1/2026 يوم الاثنين',
      dayKey: 'mon',
      time: '12:30 – 3:30 م',
      location: 'قاعة (3)',
      requirements:
        'المتحدثون: محمد عمران أحمد علي الصوص. تقديم شهادة الكترونية من Informa. شاشة عرض و مايكروفون. فليب تشارت ومقلب شرائح.',
      capacity: '-',
    },
    {
      id: 3,
      title: 'أساسيات إدارة المشاريع للشباب: تمكين الطلاب من قيادة مشاريع ناجحة',
      organization: 'PMI',
      status: 'مؤكد',
      goal: 'تزويد المشاركين بفهم أساسي لمبادئ إدارة المشاريع وأدوات التخطيط العملية، وتمكينهم من تطبيق هذه المفاهيم بشكل تعاوني في المشاريع الأكاديمية والعملية.',
      language: ['عربي'],
      audience: ['طلاب'],
      level: ['أساسي'],
      date: '19/1/2026 يوم الاثنين',
      dayKey: 'mon',
      time: '12:30 – 3:30 م',
      location: 'قاعة (4)',
      requirements:
        'المتحدثون: مريم جنى نابوت، محمد بطراوي. تقديم شهادة حضور من PMI. ملاحظات لاصقة (واحدة لكل مجموعة/طاولة). أقلام فلوماستر (2–3 لكل مجموعة). لوحة ورقية كبيرة (Flip Chart) أو لوح/ورق كرتوني (لكل مجموعة). طباعة الأوراق (سيتم إرسالها من قبل PMI في رسالة بريد إلكتروني منفصلة).',
      capacity: '-',
    },
    {
      id: 4,
      title: 'Future Leader Readiness Open Discussion',
      organization: 'CIPD',
      status: 'مؤكد',
      goal: 'An interactive discussion bringing together faculty members and leaders to explore future leader readiness and exchange insights on emerging challenges and opportunities.',
      language: ['انجليزي'],
      audience: ['أعضاء هيئة تدريس', 'قياديين'],
      level: ['-'],
      date: '19/1/2026 يوم الاثنين',
      dayKey: 'mon',
      time: '2:15 – 3:45 م',
      location: 'قاعة (5)',
      requirements: 'المتحدثون: Goumena Bteddini.',
      capacity: '-',
    },
    {
      id: 5,
      title: 'The Future of HR as an Academic Major',
      organization: 'CIPD',
      status: 'مؤكد',
      goal: 'This workshop introduces HR as a strategic academic discipline and long-term profession, not just an administrative career.',
      language: ['انجليزي'],
      audience: ['أعضاء هيئة تدريس', 'موظفين', 'طلاب'],
      level: ['أساسي'],
      date: '19/1/2026 يوم الاثنين',
      dayKey: 'mon',
      time: '12:30 م الى 2:00 م',
      location: 'قاعة (5)',
      requirements: 'المتحدثون: Goumena Bteddini. سبورة بيضاء وشاشة وميكروفون.',
      capacity: '-',
    },
    {
      id: 6,
      title: 'جلسة تطوير القيادات وتمكينها Leadership Growth Exchange',
      organization: 'IBM',
      status: 'مؤكد',
      goal: 'جلسة حوارية مخصّصة للقيادات مع خبير قيادي من IBM. تعتمد الجلسة على الحوار المفتوح والتفاعل المباشر، بعيدًا عن القوالب التقليدية، بما يعزّز التفكير القيادي، ويوسّع الآفاق، ويعمّق الفهم من خلال التجربة المشتركة.',
      language: ['انجليزي'],
      audience: ['قيادات الأكاديمية والتنفيذية'],
      level: ['-'],
      date: '20/1/2026 يوم الثلاثاء',
      dayKey: 'tue',
      time: '10:00 – 11:30 ص',
      location: 'قاعة (1)',
      requirements:
        'المتحدثون: سوميا كينان. المقاعد محدودة حسب الطاقة الاستيعابية 10-12.',
      capacity: '-',
    },
    {
      id: 7,
      title: 'أساسيات إدارة المشاريع للمحترفين',
      organization: 'PMI',
      status: 'مؤكد',
      goal: 'تعزيز فهم المشاركين لدور المشاريع في تحقيق الأهداف الاستراتيجية، وتنمية قدرتهم على تطبيق نهج قيادي قائم على تحقيق القيمة في إدارة أصحاب المصلحة والمخاطر والتغيير ضمن البيئات الأكاديمية والمؤسسية.',
      language: ['عربي'],
      audience: ['أعضاء هيئة تدريس', 'موظفين', 'طلاب'],
      level: ['متقدم'],
      date: '20/1/2026 يوم الثلاثاء',
      dayKey: 'tue',
      time: '10:00 ص – 1:00 م',
      location: 'قاعة (3)',
      requirements:
        'المتحدثون: مريم جنى نابوت، محمد بطراوي. تقديم شهادة حضور من PMI. ملاحظات لاصقة (واحدة لكل مجموعة/طاولة). أقلام فلوماستر (2–3 لكل مجموعة). لوحة ورقية كبيرة (Flip Chart) أو لوح/ورق كرتوني (لكل مجموعة). طباعة الأوراق (سيتم إرسالها من قبل PMI في رسالة بريد إلكتروني منفصلة).',
      capacity: '-',
    },
    {
      id: 8,
      title: 'الذكاء الاصطناعي والمهارات الرقمية',
      organization: 'Informa',
      status: 'مؤكد',
      goal: 'تعرّف هذه الدورة المشاركين بعالم الذكاء الاصطناعي وتأثيره المتزايد على الإنتاجية الشخصية والمهنية.',
      language: ['انجليزي', 'عربي'],
      audience: ['أعضاء هيئة تدريس', 'موظفين', 'طلاب'],
      level: ['أساسي', 'متوسط'],
      date: '20/1/2026 يوم الثلاثاء',
      dayKey: 'tue',
      time: '10:00 ص – 1:00 م',
      location: 'قاعة (5)',
      requirements:
        'المتحدثون: Hadi Aridi. يفضل الإلمام بأدوات الذكاء الاصطناعي. تقديم شهادة الكترونية من Informa. شاشة عرض و مايكروفون. فليب تشارت. مقلب شرائح.',
      capacity: '-',
    },
    {
      id: 9,
      title: 'Teaching with Cases',
      organization: 'Harvard',
      status: 'مؤكد',
      goal: 'Teaching with Cases is a hands-on, practical workshop that helps instructors use the case method to create engaging, student-centered classroom discussions.',
      language: ['انجليزي'],
      audience: ['أعضاء هيئة التدريس'],
      level: ['أساسي'],
      date: '20/1/2026 يوم الثلاثاء',
      dayKey: 'tue',
      time: '10:00 ص – 12:30 م',
      location: 'قاعة (4)',
      requirements:
        'المتحدثون: Dr Peter Bryant. إحضار أجهزة الحاسب المحمول أو أجهزة لوحية. خمس أو ست طاولات مستديرة. خمس أو ست كراسي لكل طاولة. جهاز عرض وشاشة. خمس أو ست لوحات ورقية وأقلام. سبورة واتصال بالإنترنت.',
      capacity: '-',
    },
    {
      id: 10,
      title: 'Empowering Educators with AI: Mastering Retrieval-Augmented Generation',
      organization: 'IBM',
      status: 'مؤكد',
      goal: 'To enhance future-ready education by promoting innovative teaching practices, strengthening digital collaboration, leveraging data-driven insights.',
      language: ['انجليزي'],
      audience: ['أعضاء هيئة التدريس'],
      level: ['أساسي', 'متوسط'],
      date: '20/1/2026 يوم الثلاثاء',
      dayKey: 'tue',
      time: '12:30 – 4:00 م',
      location: 'قاعة الدرعية',
      requirements:
        'المتحدثون: Safae، Ashraf Moideen، Hari Krishnan، Essam Alfehmi، Neaam Hariri. -احضار جهاز حاسب محمول بمواصفات (8GB RAM, i5 or equivalent). -يفضل الإلمام بأدوات الذكاء الاصطناعي. - سوف يتم ارسال رابط لأنشاء حساب IBM Cloud التجريبي قبل بدء ورشة العمل. تقديم شهادة الكترونية من IBM. جهاز عرض وشاشة موثوقان للعروض التقديمية. ميكروفونات وسماعات لضمان وضوح الصوت أثناء الجلسات. إنترنت عالي السرعة (10 ميجابت في الثانية كحد أدنى لكل مستخدم).',
      capacity: '-',
    },
    {
      id: 11,
      title:
        'From Fikrah to Fi‘l: Empowering Discovery and Decision-Making at KSU for Vision 2030',
      organization: 'Chicago booth',
      status: 'مؤكد',
      goal: 'Build leaders’ innovation mindset and discovery skills to reduce uncertainty, test assumptions early, and translate insight into confident strategic decisions.',
      language: ['انجليزي'],
      audience: ['أعضاء هيئة تدريس', 'موظفين', 'طلاب'],
      level: ['أساسي'],
      date: '20/1/2026 يوم الثلاثاء',
      dayKey: 'tue',
      time: '12:30 – 3:30 م',
      location: 'قاعة الدروازه',
      requirements:
        'المتحدثون: James Janega. مساحة تتسع لأنشطة المجموعات الصغيرة وتضمن تركيزًا كاملًا من جميع المشاركين. خمسة سبورات بيضاء وأقلام قابلة للمسح (أو دفاتر ملاحظات كبيرة على حوامل مع أقلام) لكل مجموعة من المجموعات الخمس. أوراق وأقلام للكتابة عليها وتدوين الملاحظات. شاشة عرض كبيرة لعرض عروض PowerPoint التقديمية.',
      capacity: '-',
    },
    {
      id: 12,
      title: 'الإدارة من الجيل القادم: تطوير المهارات لتعظيم الأثر',
      organization: 'معهد الإدارة',
      status: 'مؤكد',
      goal: 'تنمية قدرات الموارد البشرية في تبنّي مفاهيم الإدارة من الجيل القادم، من خلال تطوير المهارات الإدارية والاستراتيجية الحديثة، وتعزيز الكفاءة المؤسسية.',
      language: ['العربية'],
      audience: ['أعضاء هيئة تدريس', 'موظفين', 'طلاب'],
      level: ['متقدم'],
      date: '20/1/2026 يوم الاثنين',
      dayKey: 'mon',
      time: '1:30 – 4:00 م',
      location: 'قاعة (5)',
      requirements: 'المتحدث: منى يحيى عبدالكريم الزيد. لا يوجد.',
      capacity: '-',
    },
    {
      id: 13,
      title: 'قهوة مع خبير من IBM',
      organization: 'IBM',
      status: 'مؤكد',
      goal: 'تجربة حوارية خاصة تجمعك مباشرة مع خبير عالمي من IBM. تهدف الجلسة لدعمك مــن خلال مساعدتك فــي استكشاف مستقبل التعليم وسوق العمل بما يتناسب مع احتياجاتك، وفهم متطلبات السوق في عصر التحول الرقمي.',
      language: ['انجليزي'],
      audience: ['القياديين', 'طلاب'],
      level: ['-'],
      date: '20/1/2026 يوم الاثنين',
      dayKey: 'mon',
      time: '1:00 م – 3:00 م',
      location: 'قاعة (1)',
      requirements: 'المتحدث: سوميا كينان.',
      capacity: '-',
    },
    {
      id: 14,
      title: 'Teaching with Business Simulation Games',
      organization: 'Harvard',
      status: 'مؤكد',
      goal: 'Discover how to teach with business simulations: explore best practices, experience a Harvard simulation, and examine the benefits and risks of AI feedback.',
      language: ['انجليزي'],
      audience: ['أعضاء هيئة التدريس'],
      level: ['أساسي'],
      date: '20/1/2026 يوم الثلاثاء',
      dayKey: 'tue',
      time: '1:00 م الى 3:30 م',
      location: 'قاعة (4)',
      requirements:
        'المتحدث: Dr Tim Rogmans. إحضار أجهزة الحاسب المحمول أو أجهزة لوحية. خمس أو ست طاولات مستديرة. خمس أو ست كراسي لكل طاولة. جهاز عرض وشاشة. خمس أو ست لوحات ورقية وأقلام. سبورة واتصال بالإنترنت.',
      capacity: '-',
    },
    {
      id: 15,
      title: 'Find the Hidden Gems for Your Course on the Harvard Platform',
      organization: 'Harvard',
      status: 'مؤكد',
      goal: 'To help instructors explore the Harvard platform to identify high-quality cases and teaching resources that fit course objectives and enhance student-centered learning.',
      language: ['انجليزي'],
      audience: ['أعضاء هيئة التدريس'],
      level: ['أساسي'],
      date: '20/1/2026 يوم الثلاثاء',
      dayKey: 'tue',
      time: '3:45 – 4:45 م',
      location: 'قاعة (4)',
      requirements:
        'المتحدث: Mr stefaan Van Waes. إحضار أجهزة الحاسب المحمول أو أجهزة لوحية. منح المسجلين من أعضاء هيئة التدريس صلاحية للدخول Harvard Platform. خمس أو ست طاولات مستديرة. خمس أو ست كراسي لكل طاولة. جهاز عرض وشاشة. خمس أو ست لوحات ورقية وأقلام. سبورة واتصال بالإنترنت.',
      capacity: '-',
    },
    {
      id: 16,
      title: 'تمكين القدرات البشرية في قطاع التنمية',
      organization: 'CIFAL Center',
      status: 'مؤكد',
      goal: 'تعزيز الجهود الداعمة لتطوير القطاع التنموي',
      language: ['عربي'],
      audience: ['أعضاء هيئة تدريس', 'موظفين', 'طلاب'],
      level: ['متقدم'],
      date: '20/1/2026 يوم الثلاثاء',
      dayKey: 'tue',
      time: '1:30 – 4:30 م',
      location: 'قاعة (3)',
      requirements:
        'المتحدث: أ.د. فيصل بن فرج المطيري. تقديم شهادة حضور من مركز سيفال السعودية التابع لمعهد الأمم المتحدة للبحث والتدريب. تشتمل على طاولات دائرية الشكل تتسع كل طاولة لخمسة متدربين.',
      capacity: '-',
    },
    {
      id: 17,
      title:
        'AI Across Disciplines: Empowering Educators in Software, Cybersecurity, and Data Science',
      organization: 'IBM',
      status: 'مؤكد',
      goal: 'To enhance future-ready education by promoting innovative teaching practices, strengthening digital collaboration, leveraging data-driven insights.',
      language: ['انجليزي'],
      audience: ['أعضاء هيئة التدريس'],
      level: ['أساسي', 'متوسط'],
      date: '21/1/2026 يوم الاربعاء',
      dayKey: 'wed',
      time: '12:30 – 3:30 م',
      location: 'قاعة الدرعية',
      requirements:
        'المتحدثون: Safae، Majed Alrogi، Bhavna Sharma، Vishal Rajapriyar، Amal Alahmadi، Mohammed Aldawsari. -احضار جهاز حاسب محمول بمواصفات (8GB RAM, i5 or equivalent). -يفضل الإلمام بأدوات الذكاء الاصطناعي. -معرفة أساسه بمفاهيم البرمجة. - سوف يتم ارسال رابط لإنشاء حساب IBM Cloud التجريبي قبل بدء ورشة العمل. تقديم شهادة الكترونية IBM. • جهاز عرض وشاشة موثوقان للعروض التقديمية. • ميكروفونات وسماعات لضمان وضوح الصوت أثناء الجلسات. • إنترنت عالي السرعة (10 ميجابت في الثانية كحد أدنى لكل مستخدم).',
      capacity: '-',
    },
    {
      id: 18,
      title:
        'From Fikrah to Fi‘l: Empowering Discovery and Decision-Making at KSU for Vision 2030',
      organization: 'Chicago  booth',
      status: 'مؤكد',
      goal: 'Build leaders’ innovation mindset and discovery skills to reduce uncertainty, test assumptions early, and translate insight into confident strategic decisions.',
      language: ['انجليزي'],
      audience: ['أعضاء هيئة تدريس', 'موظفين', 'طلاب'],
      level: ['أساسي'],
      date: '21/1/2026 يوم الاربعاء',
      dayKey: 'wed',
      time: '10:00 ص الى 1:00 م',
      location: 'قاعة الدروازه',
      requirements:
        'المتحدثون: James Janega. مساحة تتسع لأنشطة المجموعات الصغيرة وتضمن تركيزًا كاملًا من جميع المشاركين. خمسة سبورات بيضاء وأقلام قابلة للمسح (أو دفاتر ملاحظات كبيرة على حوامل مع أقلام) لكل مجموعة من المجموعات الخمس. أوراق وأقلام للكتابة عليها وتدوين الملاحظات. شاشة عرض كبيرة لعرض عروض PowerPoint التقديمية.',
      capacity: '-',
    },
    {
      id: 19,
      title: 'دور مؤسسات التنمية في تمكين كبار السن : جامعة العمر الثالث نموذجاً',
      organization: 'CIFAL Center',
      status: 'مؤكد',
      goal: 'مناقشة الدور المطلوب من قبل المؤسسات التنموية في تمكين كبار السن"',
      language: ['العربية'],
      audience: ['أعضاء هيئة تدريس', 'موظفين', 'طلاب'],
      level: ['متقدم'],
      date: '21/1/2026 يوم الاربعاء',
      dayKey: 'wed',
      time: '1:30 م الى 4:30 م',
      location: 'قاعة (3)',
      requirements:
        'المتحدث: أ.د. فيصل بن فرج المطيري. تقديم شهادة حضور من مركز سيفال السعودية التابع لمعهد الأمم المتحدة للبحث والتدريب. تشتمل على طاولات دائرية الشكل تتسع كل طاولة لخمسة متدربين.',
      capacity: '-',
    },
    {
      id: 20,
      title: 'Teaching with Cases',
      organization: 'Harvard',
      status: 'مؤكد',
      goal: 'Teaching with Cases is a hands-on, practical workshop that helps instructors use the case method to create engaging, student-centered classroom discussions.',
      language: ['انجليزي'],
      audience: ['أعضاء هيئة التدريس'],
      level: ['أساسي'],
      date: '21/1/2026 يوم الاربعاء',
      dayKey: 'wed',
      time: '10:00 ص – 12:30 م',
      location: 'قاعة (4)',
      requirements:
        'المتحدث: Dr Peter Bryant. إحضار أجهزة الحاسب المحمول أو أجهزة لوحية. خمس أو ست طاولات مستديرة. خمس أو ست كراسي لكل طاولة. جهاز عرض وشاشة. خمس أو ست لوحات ورقية وأقلام. سبورة اتصال بالإنترنت.',
      capacity: '-',
    },
    {
      id: 21,
      title: 'Teaching with Business Simulation Games',
      organization: 'Harvard',
      status: 'مؤكد',
      goal: 'Discover how to teach with business simulations: explore best practices, experience a Harvard simulation, and examine the benefits and risks of AI feedback.',
      language: ['انجليزي'],
      audience: ['أعضاء هيئة التدريس'],
      level: ['أساسي'],
      date: '21/1/2026 يوم الاربعاء',
      dayKey: 'wed',
      time: '1:00 م – 3:30 م',
      location: 'قاعة (4)',
      requirements:
        'المتحدث: Dr Tim Rogmans. إحضار أجهزة الحاسب المحمول أو أجهزة لوحية. خمس أو ست طاولات مستديرة. خمس أو ست كراسي لكل طاولة. جهاز عرض وشاشة. اتصال بالإنترنت.',
      capacity: '-',
    },
    {
      id: 22,
      title: 'عمل الإدارة من الجيل القادم',
      organization: 'المركز الوطني لقياس أداء الأجهزة العامة (أداء)',
      status: 'مؤكد',
      goal: 'تمكين من مواءمة الخطة الاستراتيجية وتعميمها بفعالية بما يضمن اتساق الأهداف ومؤشرات الأداء وتحقيق النتائج المستهدفة.',
      language: ['العربية'],
      audience: ['الطلاب'],
      level: ['أساسي'],
      date: '26/1/2026 يوم الاثنين',
      dayKey: 'mon',
      time: '10:00 ص – 1:00 م',
      location: 'قاعة (4)',
      requirements:
        'المتحدث: جواهر فهد الجبرين. المتطلبات لإقامة ورشة العمل : مستزمات الترتيب والتنظيم: تجهيز القاعة التدريبية تسع لعدد 25 متدرب بكراسي وطاولات مستديرة(5 مجموعات). لوحات إرشادية. طباعة أسماء المشاركين. تسجيل أسماء الحضور. تجهيزات العرض والتقديم: شاشة عرض (Projector) وميكرفون ومكبرات صوت. تجهيزات الأدوات المكتبية: أقلام ودفاتر ملاحظات. سبورة فليب تشارت(Flip Chart) مع الورق والأقلام (لكل مجموعة). المستلزمات التقنية: خدمة إنترنت Wi-Fi. الخدمات اللوجستية: توفير الضيافة.',
      capacity: '-',
    },
    {
      id: 25,
      title: 'مستشار المستقبل: بناء علماء الغد',
      organization: 'ثروة',
      status: 'مؤكد',
      goal: 'رفع الوعي بالجدارات السلوكية والفنية لمستشاري المستقبل.',
      language: ['العربية'],
      audience: ['أعضاء هيئة تدريس', 'موظفين', 'طلاب'],
      level: ['متوسط'],
      date: '27/1/2026 يوم الثلاثاء',
      dayKey: 'tue',
      time: '10:00 ص – 1:00 م',
      location: 'قاعة (3)',
      requirements: 'المتحدث: معاذ إبراهيم علي الجعفري. شاشة عرض. جهاز كمبيوتر.',
      capacity: '-',
    },
    {
      id: 26,
      title: 'الحوكمة في القطاع العام',
      organization: '(أكاديمية الحوكمة)',
      status: 'مؤكد',
      goal: 'تعزيز مفهوم الحوكمة المؤسسية بوصفها إطارًا عمليًا لممارسة السلطة واتخاذ القرار العام بمسؤولية.',
      language: ['العربية'],
      audience: ['أعضاء هيئة تدريس', 'موظفين', 'طلاب'],
      level: ['متقدم'],
      date: '27/1/2026 يوم الثلاثاء',
      dayKey: 'tue',
      time: '10:00 ص – 1:00 م',
      location: 'قاعة (4)',
      requirements: 'المتحدث: المستشار خالد بن غضيان العنزي. جهاز عرض شرائح.',
      capacity: '-',
    },
    {
      id: 27,
      title: 'من طالب إلى محترف جاهز لسوق العمل',
      organization: '(أكاديمية السعودية الرقمية)',
      status: 'مؤكد',
      goal: 'تمكين الطلبة من الانتقال الواعي والمنهجي من المرحلة الأكاديمية إلى الحياة المهنية.',
      language: ['العربية'],
      audience: ['طلاب'],
      level: ['متوسط', 'متقدم'],
      date: '27/1/2026 يوم الثلاثاء',
      dayKey: 'tue',
      time: '10:00 ص – 1:00 م',
      location: 'قاعة (5)',
      requirements: 'المتحدث: فهد محمد الأحمري. جهاز عرض. صوتيات مناسبة.',
      capacity: '-',
    },
    {
      id: 28,
      title: 'تصميم التكليفات التعليمية في عصر الذكاء الاصطناعي',
      organization: 'مركز التميز في التعليم والتعلم',
      status: 'مؤكد',
      goal: 'تمكين أعضاء هيئة التدريس من تصميم تكليفات وتقييمات ذكية تقيس تعلم الطلبة الحقيقي وتنمي مهارات التفكير العليا.',
      language: ['العربية'],
      audience: ['أعضاء هيئة تدريس'],
      level: ['أساسي'],
      date: '27/1/2026 يوم الاثنين',
      dayKey: 'mon',
      time: '1:30 م – 4:30 م',
      location: 'قاعة (3)',
      requirements:
        'المتحدث: د. مشاعل الطوب. إحضار أجهزة الحاسب المحمول أو أجهزة لوحية. يفضل الإلمام بأدوات الذكاء الاصطناعي. المتطلبات الفنية: قاعة تدريب مجهزة بشاشة عرض أو شاشة تفاعلية وجهاز عرض (Data show). نظام صوتي مناسب وميكروفون لضمان وضوح العرض والنقاش. المتطلبات اللوجستية: تنسيق جدول ورش العمل وتحديد المدة الزمنية وعدد المشاركين. تنسيق نشر المواد التدريبية رقمية للمشاركين. توفير فريق دعم أثناء الورشة. تهيئة القاعة بما يدعم العمل الجماعي والنقاش التفاعلي. توفير ضيافة خفيفة عند الحاجة.',
      capacity: '-',
    },
  ]
  

  // Helper to normalize date to day portion only (e.g., "19/1/2026")
  const getDateKey = dateStr => dateStr.split(' ')[0]

  // Build date filters from the data itself to avoid manual upkeep
  const dateOptions = [
    { key: 'all', label: 'الكل' },
    ...Array.from(
      new Map(workshops.map(w => [getDateKey(w.date), getDateKey(w.date)]))
    ).map(([key, label]) => ({ key, label })),
  ]

  const [activeDate, setActiveDate] = useState('all')

  const filtered =
    activeDate === 'all'
      ? workshops
      : workshops.filter(w => getDateKey(w.date) === activeDate)
  return (
    <section className="bg-slate-50 py-24 px-4" dir="rtl">
      <div className="max-w-7xl mx-auto">

        {/* Header */}
        <h1 className="text-5xl font-bold text-sky-700 text-center mb-12">
          ورش العمل
        </h1>

        {/* Tabs */}
        <div className="flex justify-center gap-3 mb-12 flex-wrap">
          {dateOptions.map(day => (
            <button
              key={day.key}
              onClick={() => setActiveDate(day.key)}
              className={`px-6 py-2 rounded-full text-sm font-bold transition
                ${
                  activeDate === day.key
                    ? 'bg-sky-700 text-white'
                    : 'bg-white text-slate-700 border'
                }`}
            >
              {day.label}
            </button>
          ))}
        </div>

        {/* Cards */}
        <div className="space-y-6">
          {filtered.map(workshop => (
            <WorkshopCard key={workshop.id} workshop={workshop} />
          ))}
        </div>

      </div>
    </section>

  )
}
function WorkshopCard({ workshop }) {
  return (
    <div
      dir="rtl"
      className="
        group relative bg-white
        rounded-3xl border border-slate-200
        p-8 transition
        hover:shadow-xl hover:-translate-y-1
      "
    >
      {/* Header */}
      <div className="flex justify-between items-start mb-4">
        <div>
          <h3 className="text-xl font-extrabold text-slate-900 leading-snug">
            {workshop.title}
          </h3>
          <p className="text-sm font-semibold text-sky-700 mt-1">
            {workshop.organization}
          </p>
        </div>
      </div>

      {/* Goal */}
      <p className="text-slate-700 leading-relaxed mb-6">
        {workshop.goal}
      </p>

      {/* Badges */}
      <div className="flex flex-wrap gap-2 mb-6">
        {workshop.language.map(l => (
          <Badge key={l} label={l} />
        ))}
        {workshop.audience.map(a => (
          <Badge key={a} label={a} />
        ))}
        {workshop.level.map(lv => (
          <Badge key={lv} variant="level" label={lv} />
        ))}
      </div>

      {/* Meta */}
      <div className="grid sm:grid-cols-2 gap-3 text-sm text-slate-600">
        <div>📅 {workshop.date}</div>
        <div>⏰ {workshop.time}</div>
        <div>📍 {workshop.location}</div>
        {/* <div>👥 عدد الحضور: {workshop.capacity}</div> */}
      </div>

      {/* Footer */}
      {/* {workshop.requirements !== '-' && (
        <div className="mt-6 rounded-xl bg-slate-50 p-4 text-sm">
          <span className="font-bold text-slate-700">
            متطلبات خاصة:
          </span>{' '}
          {workshop.requirements}
        </div>
      )} */}
    </div>
  )
}

function Badge({ label, variant = 'default' }) {
  return (
    <span
      className={`
        text-xs font-semibold px-3 py-1 rounded-full
        ${
          variant === 'level'
            ? 'bg-indigo-100 text-indigo-800'
            : 'bg-sky-100 text-sky-800'
        }
      `}
    >
      {label}
    </span>
  )
}
